import React, { Component } from "react";
import { connect } from "react-redux";
import { actions } from "./redux";
import CSSModules from "react-css-modules";
import moment from "moment";
import seriesColor from "../../../../utils/seriesColor";

import styles from "./styles.scss";
import { shouldUpdate, number, tooltip, units } from "../../../../utils";

let count = 0;
const idPrefix = "LineChart";


@CSSModules(styles, { allowMultiple: true })
class ChartTooltip extends Component {
	constructor(props) {
		super(props);

		this.scrollOverride = this.scrollOverride.bind(this);
	}
	render() {
		return (
			<div id="chart-container">
				{
					this.props.isMouseIn &&
					<div id="rss-chart-tooltip" className="pst-tooltip" style={{visibility: "hidden", height: "0px"}}>
						 <div>
							  <div className="date-description">
									{this.props.tooltipData && moment.utc(this.props.tooltipData.time).format("dddd, MMM DD, hh:mm A")}
							  </div>
							  {
								  this.props.tooltipData && 
								  this.props.tooltipData.data.map(function(d, index) {
									  if(d && d.comment) {
										  return <div className="major-description description" key={index}><span style={{color: d.color}}>{d.name}:</span> {d.comment}</div>;
									  }
									  if(!d || !d.nearest) {
										  return <div key={index}></div>;
									  }
									  return <div className="major-description description" key={index}><span style={{color: d.color}}>{d.name}:</span> {number.parseNumber(d.nearest.y, units.stringToDecimalPlaces(d.units))} {units.stringToSymbol(d.units)}</div>
								  })
							  }
						 </div>
					</div>
			  }
			  {
				  this.props.isMouseIn &&
					<div id="rss-chart-bar" className="pst-bar" style={{visibility: "hidden", height: "0px"}}>
						<div className="rss-chart-bar"></div>
					</div>
			  }
			  </div>
		);
	}

	scrollOverride(e) {
		this.props.override();
	}

	setup() {
		document.getElementById("content-scroll").addEventListener('scroll', this.scrollOverride);
	}

	teardown() {}

	componentDidMount() {
		this.setup();
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		this.setup();
	}

	componentWillUnmount() {
		document.getElementById("content-scroll").removeEventListener('scroll', this.scrollOverride);
	}

	shouldComponentUpdate(nextProps, nextState) {
		return shouldUpdate(this, nextProps, nextState, ["onLoadComplete"]);
	}
}

const bindAction = dispatch => {
	return {
		unmount: () => dispatch(actions.unmount()),
		override: () => dispatch(actions.override())
	};
};

const mapStateToProps = (state, ownProps) => ({
	isMouseIn: state.charttooltip.isMouseIn,
	tooltipData: state.charttooltip.tooltipData,
	isMenuOpen: state.menu.isOpen
});

export default connect(
	mapStateToProps,
	bindAction
)(ChartTooltip);



// WEBPACK FOOTER //
// ./src/components/ReportComponents/Charts/ChartTooltip/ChartTooltip.js